import React from 'react';
import { Timer, RotateCcw, Play, Info } from 'lucide-react';

const GameInfo = ({
    selectedItem,
    gameMode,
    numPlayers,
    numSpies,
    gameTimer,
    timeLeft,
    onBackToTimer,
    onNewGame,
    onAnotherRound,
    t
}) => {
    const isTimerStillRunning = timeLeft > 0;

    return (
        <div className="border-t border-spy-border pt-6 text-center">
            <div>
                <p className="mb-3 text-[10.5px] font-semibold uppercase tracking-[0.22em] text-spy-primary">
                    Dossier
                </p>
                <h2 className="mb-6 flex items-center justify-center gap-2 font-display text-[32px] font-medium leading-tight text-spy-text">
                    <Info className="h-6 w-6 text-spy-primary" />
                    <span>{t.gameInfo}</span>
                </h2>

                {/* Game Details */}
                <div className="mb-6 border-y border-spy-border py-2 text-left">
                    <div className="divide-y divide-spy-border">
                        <p className="flex justify-between py-3 text-sm text-spy-text">
                            <strong>{gameMode === 'location' ? t.location : t.person}:</strong> {selectedItem}
                        </p>
                        <p className="flex justify-between py-3 text-sm text-spy-muted">
                            <strong>{t.players}:</strong> {numPlayers}
                        </p>
                        <p className="flex justify-between py-3 text-sm text-spy-muted">
                            <strong>{t.spies}:</strong> {numSpies}
                        </p>
                        <p className="flex justify-between py-3 text-sm text-spy-muted">
                            <strong>{t.timer}:</strong> {gameTimer} {t.minutes}
                        </p>
                    </div>
                </div>

                {/* Buttons */}
                <div className="space-y-3">
                    {/* Back to Timer - Only if timer is still running */}
                    {isTimerStillRunning && (
                        <button
                            onClick={onBackToTimer}
                            className="flex min-h-[52px] w-full items-center justify-center space-x-2 rounded-spy bg-spy-text px-6 py-4 text-[15px] font-semibold text-spy-bg hover:opacity-90"
                        >
                            <Timer className="w-5 h-5" />
                            <span>Back to Timer</span>
                        </button>
                    )}

                    {/* Another Round - Always available in game info */}
                    <button
                        onClick={onAnotherRound}
                        className="flex min-h-[52px] w-full items-center justify-center space-x-2 rounded-spy border border-spy-border2 bg-transparent px-6 py-4 text-[15px] font-semibold text-spy-soft hover:border-spy-primary hover:text-spy-primary"
                    >
                        <Play className="w-5 h-5" />
                        <span>{t.anotherRound}</span>
                    </button>

                    {/* New Game */}
                    <button
                        onClick={onNewGame}
                        className="flex min-h-[52px] w-full items-center justify-center space-x-2 rounded-spy border border-spy-border2 bg-transparent px-6 py-4 text-[15px] font-semibold text-spy-muted hover:border-spy-danger hover:text-spy-danger"
                    >
                        <RotateCcw className="w-5 h-5" />
                        <span>{t.newGame}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GameInfo;
